module.exports = {"name":"frontiersmen-client","version":"0.2.0","private":true,"homepage":"https://frontiersmen.github.io","dependencies":{"@material-ui/core":"^1.4.3","@material-ui/icons":"^2.0.1","ajv":"^6.5.2","gh-pages":"^1.2.0","npm":"^6.3.0","react":"^16.4.2","react-dom":"^16.4.2","react-router-dom":"^4.3.1","react-scripts":"1.1.4"},"scripts":{"predeploy":"npm run build","deploy":"gh-pages -o deployment -b master -d build","start":"react-scripts start","build":"react-scripts build","test":"react-scripts test --env=jsdom","eject":"react-scripts eject"}}


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 339
// module chunks = 0